import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Button, Container, Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { PDFPreviewFile } from "../../../components/PDFFileHandler";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import CardDisplayComponent from "../../../components/CardDisplayComponent";
import PreviewRepairPrintForm from "../../../components/RepairWork/PreviewRepairPrintForm";
import FileUploadsService from "../../../services/fileupload.service";

export default function PreviewRepairNotification() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [PreviewPDF, setPreviewPDF] = useState(null);

  const displayPDFComponent = ({ file }) => (
    <CardDisplayComponent
      header={{
        title: { className: "text-center", text: "แสดงและพิมพ์ไฟล์แนบ" }
      }}
      body={{
        element: <PDFPreviewFile pdfFile={file} />
      }}
      footer={{
        className: "text-center",
        element: (
          <Button
            variant="outline-secondary"
            className="px-4 py-2_5 text-dark rounded-pill"
            onClick={() => navigate("/repair_work/record", { state })}
          >
            ย้อนกลับ
          </Button>
        )
      }}
    />
  );

  useEffect(() => {
    handleChangeWebsiteTab({
      key: state?.name,
      setWebsiteName,
      tabNames: {
        create: "สร้างใบแจ้งซ่อม",
        edit: "แก้ไขบันทึกการแจ้งซ่อม",
        search: "ข้อมูลบันทึกการแจ้งซ่อม",
        repair_email: "รายงานแจ้งซ่อมทางเมล"
      }
    });

    if (state?.name !== "create" && state?.filename) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: FileUploadsService.getFileUploads(
          "ใบแจ้งซ่อม/PDF",
          state?.filename
        ),
        callback: (res) =>
          setPreviewPDF(new Blob([res], { type: "application/pdf" }))
      });
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Record Repair Notification Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs justify activeKey={state?.name}>
          <Tab eventKey="create" title="สร้างใบแจ้งซ่อม">
            {websiteName === "สร้างใบแจ้งซ่อม" &&
              displayPDFComponent({ file: state?.data?.Media?.PDF?.blob })}
          </Tab>
          <Tab eventKey="edit" title="แก้ไขบันทึกการแจ้งซ่อม">
            {websiteName === "แก้ไขบันทึกการแจ้งซ่อม" &&
              displayPDFComponent({ file: PreviewPDF })}
          </Tab>
          <Tab eventKey="search" title="ข้อมูลบันทึกการแจ้งซ่อม">
            {websiteName === "ข้อมูลบันทึกการแจ้งซ่อม" &&
            state?.type === "print" ? (
              <PreviewRepairPrintForm />
            ) : (
              displayPDFComponent({ file: PreviewPDF })
            )}
          </Tab>
          <Tab eventKey="repair_email" title="รายงานแจ้งซ่อมทางเมล">
            {websiteName === "รายงานแจ้งซ่อมทางเมล" && <></>}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
